import React from 'react';
import { connect } from "react-redux";
import { branch, compose, renderComponent } from 'recompose';
import { businessSelector } from '../../../../state/modules/business';
import Loading from '../../loading';
import TeamDetails from './team-details';

const TeamCreate = () => (
  <div id='team-create'>
    <TeamDetails />
  </div>
);

const mapStateToProps = (state) => ({
  business: businessSelector(state),
})

const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ business }) => !business,
    renderComponent(Loading)
  ),
)(TeamCreate);


// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/team-create.js